import { useDispatch, useSelector } from "react-redux"
import { Button } from "react-bootstrap"

import { teamStatus, waiting, samples } from "state_management"
import useT from "utils/hooks/useT"

export default function PriorityButtons({iapMode, isAnalyses, isMixed}) {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const priorityMode = useSelector((state) => state.teamStatus.sortingParameter)
  return (
    <>
      <div className="RightMenuHeader-nav">
        <Button
          title={t("prioritizeByDeadline")}
          variant={priorityMode === "DEADLINE" ? "primary" : "light"}
          className="ButtonAnalysis"
          onClick={() => {
            const newPriorityMode = "DEADLINE";
            // Existing logic to handle priority change
            isAnalyses || (isMixed && iapMode === "analysis")
              ? dispatch(teamStatus.changeIAPPriority({ sortingParameter: newPriorityMode })).then(() => {
                  dispatch(waiting.changeSampleAllocating(true));
                  dispatch(samples.runSampleAllocation()).finally(() => dispatch(waiting.changeSampleAllocating(false)));
                })
              : dispatch(teamStatus.changeIAPPriority({ sortingParameter: newPriorityMode }));
          }}
        >
          {t("deadline")}
        </Button>
        <Button
          title={t("prioritizeByPriority")}
          variant={priorityMode === "PRIORITY" ? "primary" : "light"}
          className="ButtonProject"
          onClick={() => {
            const newPriorityMode = "PRIORITY";
            // Existing logic to handle priority change
            isAnalyses || (isMixed && iapMode === "analysis")
              ? dispatch(teamStatus.changeIAPPriority({ sortingParameter: newPriorityMode })).then(() => {
                  dispatch(waiting.changeSampleAllocating(true));
                  dispatch(samples.runSampleAllocation()).finally(() => dispatch(waiting.changeSampleAllocating(false)));
                })
              : dispatch(teamStatus.changeIAPPriority({ sortingParameter: newPriorityMode }));
          }}
        >
          {t("priority")}
        </Button>
      </div>
    </>
  )
}
